import { Link as RouterLink, } from 'react-router-dom';
import { useFirstMountState, } from 'react-use';
import {
    Box,
    Alert,
    Skeleton,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Grid,
    Typography,
} from '@mui/material';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { useAuth, useCollection, } from '../hooks';

const SetsPage = () => {
    const { user, } = useAuth();
    const { documents, isPending, error, } = useCollection({
        col: 'sets',
        _query: [['uid', '==', user.uid]],
        _orderBy: ['createdAt', 'asc'],
    });

    const isFirstMount = useFirstMountState();

    return (
        <Box>
            <Typography
                component='h2'
                sx={{
                    fontSize: [18, 21, 24, 27],
                    fontWeight: 700,
                }}>Все сеты</Typography>
            <Typography sx={{
                color: 'text.secondary',
                fontSize: [11, 12, 13],
                fontStyle: 'italic',
                overflowWrap: 'anywhere',
                mt: [0.25, 0.5, 0.75, 1],
                mb: [3, 4, 5, 6],
            }}>
                Выберите сет, чтобы начать работу с ним
            </Typography>
            {
                isFirstMount
                    ? null
                    : isPending
                        ?
                        <Grid container spacing={1.5} sx={{ mt: [-4, -4.5], }}>
                            {[1, 2, 3, 4, 5, 6].map((value) => {
                                return (
                                    <Grid key={value} item xs={12} md={6}>
                                        <Skeleton
                                            animation='wave'
                                            sx={{
                                                height: ['90px', '104px', '112px'],
                                                mb: [-3.45, -4],
                                                width: '100%',
                                            }} />
                                    </Grid>
                                )
                            })}
                        </Grid>
                        : error
                            ? <Alert severity='error' variant='filled'>{error.message}</Alert>
                            : documents.length > 0
                                ? <List disablePadding>
                                    <Grid container spacing={1.5}>
                                        {
                                            documents.map((doc) => {
                                                return (
                                                    <Grid key={doc.id} item xs={12} md={6}>
                                                        <Link
                                                            component={RouterLink}
                                                            to={`/set/${doc.id}`}
                                                            underline='none'
                                                            sx={{
                                                                border: 1,
                                                                borderColor: 'borderColor.main',
                                                                display: 'flex',
                                                                height: '100%',
                                                                alignItems: 'center',
                                                                '&:hover': {
                                                                    borderColor: 'secondary.main',
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'secondary.main',
                                                                    },
                                                                    '& .MuiListItemText-primary': {
                                                                        color: 'secondary.main',
                                                                    },
                                                                },
                                                            }}>
                                                            <ListItem
                                                                sx={{
                                                                    px: [1.25, 1.5, 1.75, 2],
                                                                    py: [0.5, 0.75, 1],
                                                                }}>
                                                                <ListItemIcon sx={{ minWidth: 'auto', mr: [1.25, 1.5, 1.75, 2], }}>
                                                                    <AutoAwesomeMotionIcon sx={{
                                                                        color: 'text.primary',
                                                                        fontSize: [21, 23, 25, 27],
                                                                    }} />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={doc.title}
                                                                    secondary={doc.description}
                                                                    sx={{
                                                                        '& .MuiListItemText-primary': {
                                                                            color: 'text.primary',
                                                                            display: 'block',
                                                                            fontSize: [12, 13, 14],
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                        },
                                                                        '& .MuiListItemText-secondary': {
                                                                            fontSize: [11, 12, 13],
                                                                            overflowWrap: 'anywhere',
                                                                        },
                                                                    }}
                                                                />
                                                            </ListItem>
                                                        </Link>
                                                    </Grid>
                                                )
                                            })
                                        }
                                    </Grid>
                                </List>
                                : <Typography sx={{ fontSize: 14, mt: [-1, -2, -3, -4], }}>Вы еще не создали ни одного сета. Создайте первый сет карточек.</Typography>
            }
        </Box>
    );
};

export default SetsPage;